import { createContext } from 'react';
import { MasterContextType } from '../types';

export const MasterContext = createContext({} as MasterContextType);
